var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackCheckboxChecked = function SvgBlackCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H16C17.11 0 18 0.9 18 2V16C18 17.1 17.11 18 16 18H2C0.89 18 0 17.1 0 16V2C0 0.9 0.89 0 2 0ZM13.6839 7.72954C14.0869 7.35181 14.1073 6.71897 13.7295 6.31606C13.3518 5.91315 12.719 5.89274 12.3161 6.27047L7.66667 10.6293L5.68394 8.77047C5.28103 8.39274 4.6482 8.41315 4.27047 8.81606C3.89274 9.21898 3.91315 9.85181 4.31606 10.2295L6.98273 12.7295C7.36739 13.0902 7.96595 13.0902 8.35061 12.7295L13.6839 7.72954Z",
    fill: "#282828"
  })));
};
export default SvgBlackCheckboxChecked;